import type { PageContext } from 'vike/types'

import { extractLocale } from '../utils/i18n'

export default function onBeforeRoute(pageContext: PageContext) {
  const url = pageContext.urlParsed
  const { urlPathnameWithoutLocale, locale } = extractLocale(url.pathname)
  return {
    pageContext: {
      // Make `locale` available as pageContext.locale
      locale,
      // Vike's router will use pageContext.urlLogical instead of pageContext.urlOriginal
      urlLogical: urlPathnameWithoutLocale,
    },
  }
}
